export const countries = [
  { name: 'Germany – Deutschland', id: 'Deutschland' },
  { name: 'Austria – Österreich', id: 'Österreich' },
  { name: 'Switzerland – Schweiz / Suisse / Svizzera / Svizra', id: 'Schweiz' },
  { name: 'Luxembourg – Luxembourg / Lëtzebuerg / Luxemburg', id: 'Luxemburg' },
  { name: 'Afghanistan – افغانستان (Afghanestan)', id: 'Afghanistan' },
  { name: 'Åland Islands – Åland / Ahvenanmaa', id: 'Åland' },
  { name: 'Albania – Shqipëria', id: 'Albanien' },
  { name: 'Algeria – الجزائر (Dzayer)', id: 'Algerien' },
  { name: 'Andorra – Andorra', id: 'Andorra' },
  { name: 'Angola – Angola', id: 'Angola' },
  { name: 'American Samoa – Amerika Samoa', id: 'Amerikanisch-Samoa' },
  { name: 'Anguilla – Anguilla', id: 'Anguilla' },
  { name: 'Antarctica – Antarctica', id: 'Antarktis' },
  { name: 'Antigua and Barbuda – Antigua and Barbuda', id: 'Antigua/Barbuda' },
  { name: 'Argentina – Argentina', id: 'Argentinien' },
  { name: 'Armenia – Հայաստան (Hayastán)', id: 'Armenien' },
  { name: 'Aruba – Aruba', id: 'Aruba' },
  { name: 'Azerbaijan – Azərbaycan', id: 'Aserbaidschan' },
  { name: 'Australia – Australia', id: 'Australien' },
  { name: 'Bahamas – The Bahamas', id: 'Bahamas' },
  { name: 'Bahrain – البحرين (Al-Bahrayn)', id: 'Bahrain' },
  { name: 'Bangladesh – বাংলাদেশ (Bangladesh)', id: 'Bangladesh' },
  { name: 'Bermuda – Bermuda', id: 'Bermuda' },
  { name: 'Barbados – Barbados', id: 'Barbados' },
  { name: 'Belarus – Беларусь (Bielaruś)', id: 'Weißrussland' },
  { name: 'Belgium – België / Belgique / Belgien', id: 'Belgien' },
  { name: 'Belize – Belize', id: 'Belize' },
  { name: 'Benin – Bénin', id: 'Benin' },
  { name: 'Bhutan – འབྲུག་ཡུལ་ (Druk Yul)', id: 'Bhutan' },
  { name: 'Bolivia – Bolivia / Wuliwya / Buliwya', id: 'Bolivien' },
  { name: 'Bosnia and Herzegovina – Bosna i Hercegovina / Босна и Херцеговина', id: 'Bosnien/Herzegowina' },
  { name: 'Botswana – Botswana', id: 'Botsuana' },
  { name: 'Bouvet Island – Bouvetøya', id: 'Bouvetinsel' },
  { name: 'Brazil – Brasil', id: 'Brasilien' },
  { name: 'Brunei – Negara Brunei Darussalam', id: 'Brunei Darussalam' },
  { name: 'British Virgin Islands – British Virgin Islands', id: 'Jungferninseln, Britische' },
  { name: 'Bulgaria – България (Bǎlgariya)', id: 'Bulgarien' },
  { name: 'Burkina Faso – Burkina Faso', id: 'Burkina Faso' },
  { name: 'Burundi – Burundi', id: 'Burundi' },
  { name: 'Cayman Islands – Cayman Islands', id: 'Kaimaninseln' },
  { name: 'Cambodia – កម្ពុជា (Kâmpŭchéa)', id: 'Kambodscha' },
  { name: 'Cameroon – Cameroun / Cameroon', id: 'Kamerun' },
  { name: 'Canada – Canada', id: 'Kanada' },
  { name: 'Cape Verde – Cabo Verde', id: 'Cabo Verde' },
  { name: 'Central African Republic – République centrafricaine', id: 'Zentralafrikanische Republik' },
  { name: 'Chad – Tchad', id: 'Tschad' },
  { name: 'Chile – Chile', id: 'Chile' },
  { name: 'China – 中国 (Zhōngguó)', id: 'China' },
  { name: 'Christmas Island – Christmas Island', id: 'Weihnachtsinsel' },
  { name: 'Cocos (Keeling) Islands – Cocos (Keeling) Islands', id: 'Kokosinseln' },
  { name: 'Colombia – Colombia', id: 'Kolumbien' },
  { name: 'Comoros – جزر القمر (Juzur al-Qamar)', id: 'Komoren' },
  { name: 'Congo (Brazzaville) – République du Congo', id: 'Kongo' },
  { name: 'Congo (Kinshasa) – République démocratique du Congo', id: 'Kinshasa' },
  { name: 'Cook Islands – Cook Islands', id: 'Cookinseln' },
  { name: 'Costa Rica – Costa Rica', id: 'Costa Rica' },
  { name: 'Croatia – Hrvatska', id: 'Kroatien' },
  { name: 'Cuba – Cuba', id: 'Cuba' },
  { name: 'Cyprus – Κύπρος (Kýpros) / Kıbrıs', id: 'Zypern' },
  { name: 'Czech Republic – Česká republika', id: 'Tschechien' },
  { name: 'Denmark – Danmark', id: 'Dänemark' },
  { name: 'Djibouti – جيبوتي (Jībūtī)', id: 'Dschibuti' },
  { name: 'Dominica – Dominica', id: 'Dominica' },
  { name: 'Dominican Republic – República Dominicana', id: 'Dominikanische Republik' },
  { name: 'East Timor – Timor-Leste', id: 'Timor-Leste' },
  { name: 'Ecuador – Ecuador', id: 'Ecuador' },
  { name: 'Egypt – مصر (Miṣr)', id: 'Ägypten' },
  { name: 'El Salvador – El Salvador', id: 'El Salvador' },
  { name: 'Equatorial Guinea – Guinea Ecuatorial', id: 'Äquatorialguinea' },
  { name: 'Eritrea – ኤርትራ (Eritrea)', id: 'Eritrea' },
  { name: 'Estonia – Eesti', id: 'Estland' },
  { name: 'Eswatini – Eswatini', id: 'Swasiland' },
  { name: 'Ethiopia – ኢትዮጵያ (Ītyōṗṗyā)', id: 'Äthiopien' },
  { name: 'Falkland Islands – Islas Malvinas', id: 'Falklandinseln' },
  { name: 'Faroe Islands – Føroyar', id: 'Färöer' },
  { name: 'Fiji – Fiji', id: 'Fidschi' },
  { name: 'Finland – Suomi', id: 'Finnland' },
  { name: 'France – France', id: 'Frankreich' },
  { name: 'French Guiana – Guyane', id: 'Französisch-Guayana' },
  { name: 'French Polynesia – Polynésie française', id: 'Französisch-Polynesien' },
  {
    name: 'French Southern Territories – Terres australes et antarctiques françaises',
    id: 'Französische Südpolarterritorien',
  },
  { name: 'Gabon – Gabon', id: 'Gabun' },
  { name: 'Gambia – The Gambia', id: 'Gambia' },
  { name: 'Georgia – საქართველო (Sakartvelo)', id: 'Georgien' },
  { name: 'Ghana – Ghana', id: 'Ghana' },
  { name: 'Gibraltar – Gibraltar', id: 'Gibraltar' },
  { name: 'Greenland – Kalaallit Nunaat', id: 'Grönland' },
  { name: 'Greece – Ελλάδα (Elláda)', id: 'Griechenland' },
  { name: 'Grenada – Grenada', id: 'Grenada' },
  { name: 'Guadeloupe – Guadeloupe', id: 'Guadeloupe' },
  { name: 'Guam – Guam', id: 'Guam' },
  { name: 'Guatemala – Guatemala', id: 'Guatemala' },
  { name: 'Guernsey – Guernsey', id: 'Guernsey' },
  { name: 'Guinea – Guinée', id: 'Guinea' },
  { name: 'Guinea-Bissau – Guiné-Bissau', id: 'Guinea-Bissau' },
  { name: 'Guyana – Guyana', id: 'Guyana' },
  { name: 'Haiti – Haïti / Ayiti', id: 'Haiti' },
  { name: 'Heard und McDonaldinseln', id: 'Heard und McDonaldinseln' },
  { name: 'Honduras – Honduras', id: 'Honduras' },
  { name: 'Hong Kong – 香港 (Xiānggǎng)', id: 'Hong Kong' },
  { name: 'Hungary – Magyarország', id: 'Ungarn' },
  { name: 'Iceland – Ísland', id: 'Island' },
  { name: 'India – भारत (Bhārat)', id: 'Indien' },
  { name: 'Indonesia – Indonesia', id: 'Indonesien' },
  { name: 'Iran – ایران (Īrān)', id: 'Iran' },
  { name: 'Iraq – العراق (Al-‘Irāq)', id: 'Irak' },
  { name: 'Ireland – Éire', id: 'Irland' },
  { name: "Israel – יִשְׂרָאֵל (Yisra'el) / إسرائيل (Isrā'īl)", id: 'Israel' },
  { name: 'Isle Of Man - Isle Of Man', id: 'Isle Of Man' },
  { name: 'Italy – Italia', id: 'Italien' },
  { name: 'Ivory Coast – Côte d’Ivoire', id: 'Elfenbeinküste' },
  { name: 'Jamaica – Jamaica', id: 'Jamaika' },
  { name: 'Japan – 日本 (Nihon/Nippon)', id: 'Japan' },
  { name: 'Jordan – الأردن (Al Urdun)', id: 'Jordanien' },
  { name: 'Jersey – Jersey', id: 'Jersey' },
  { name: 'Kazakhstan – Қазақстан (Qazaqstan)', id: 'Kasachstan' },
  { name: 'Kenya – Kenya / Jamhuri ya Kenya', id: 'Kenia' },
  { name: 'Kiribati – Kiribati / Ribaberiki Kiribati', id: 'Kiribati' },
  { name: 'Kuwait – الكويت (Al Kuwayt) / دولة الكويت (Dawlat al Kuwayt)', id: 'Kuwait' },
  { name: 'Kyrgyzstan – Кыргызстан (Kyrgyzstan)', id: 'Kirgisistan' },
  { name: 'Laos – ສປປລາວ (Sathalanalat Paxathipatai Paxaxôn Lao)', id: 'Laos' },
  { name: 'Latvia – Latvija / Latvijas Republika', id: 'Lettland' },
  { name: 'Lebanon – لبنان (Lubnān) / الجمهورية اللبنانية (Al Jumhūrīyah al Lubnānīyah)', id: 'Libanon' },
  { name: 'Lesotho – Lesotho', id: 'Lesotho' },
  { name: 'Liberia – Liberia', id: 'Liberia' },
  { name: 'Libya – ليبيا (Lībyā)', id: 'Libyen' },
  { name: 'Liechtenstein – Liechtenstein / Fürstentum Liechtenstein', id: 'Liechtenstein' },
  { name: 'Lithuania – Lietuva / Lietuvos Respublika', id: 'Litauen' },
  { name: 'Macao – 澳門 (Àomén)', id: 'Macao' },
  { name: 'Madagascar – Madagasikara', id: 'Madagaskar' },
  { name: 'Malawi – Malawi', id: 'Malawi' },
  { name: 'Malaysia – Malaysia', id: 'Malaysia' },
  { name: 'Maldives – ދިވެހިރާއްޖެ (Dhivehi Raajje)', id: 'Maldiven' },
  { name: 'Mali – Mali', id: 'Mali' },
  { name: 'Malta – Malta', id: 'Malta' },
  { name: 'Marshall Islands – Aolepān Aorōkin M̧ajeļ', id: 'Marshallinseln' },
  { name: 'Mauritania – موريتانيا (Mūrītānyā)', id: 'Mauretanien' },
  { name: 'Mauritius – Maurice / Moris', id: 'Mauritius' },
  { name: 'Mayotte – Mayotte', id: 'Mayotte' },
  { name: 'Mexico – México / Estados Unidos Mexicanos', id: 'Mexiko' },
  { name: 'Micronesia – Micronesia / Federated States of Micronesia', id: 'Mikronesien' },
  { name: 'Moldova – Moldova / Republica Moldova', id: 'Moldawien' },
  { name: 'Monaco – Monaco', id: 'Monaco' },
  { name: 'Mongolia – Монгол Улс (Mongol Uls)', id: 'Mongolei' },
  { name: 'Montenegro – Crna Gora', id: 'Montenegro' },
  { name: 'Montserrat – Montserrat', id: 'Montserrat' },
  { name: 'Morocco – المغرب (Al-Maghrib)', id: 'Morokko' },
  { name: 'Mozambique – Moçambique', id: 'Mosambik' },
  { name: 'Myanmar – မြန်မာ (Myanma)', id: 'Myanmar' },
  { name: 'Namibia – Namibia', id: 'Namibia' },
  { name: 'Nauru – Nauru / Republic of Nauru', id: 'Nauru' },
  { name: 'Nepal – नेपाल (Nepāl)', id: 'Nepal' },
  { name: 'Netherlands – Nederland', id: 'Niederlande' },
  { name: 'Netherlands Antilles – Nederlandse Antillen', id: 'Niederländische Antillen' },
  { name: 'New Caledonia – Nouvelle-Calédonie', id: 'Neukaledonien' },
  { name: 'New Zealand – New Zealand / Aotearoa', id: 'Neuseeland' },
  { name: 'Nicaragua – Nicaragua', id: 'Nicaragua' },
  { name: 'Niger – Niger', id: 'Niger' },
  { name: 'Nigeria – Nigeria', id: 'Nigeria' },
  { name: 'Niue – Niue', id: 'Niue' },
  { name: 'North Korea – 조선민주주의인민공화국 (Chosŏn Minjujuŭi Inmin Konghwaguk)', id: 'Nordkorea' },
  { name: 'North Macedonia – Северна Македонија (Severna Makedonija)', id: 'Mazedonien' },
  { name: 'Northern Mariana Islands – Northern Mariana Islands', id: 'Nördliche Marianen' },
  { name: 'Norfolk Island – Norfolk Island', id: 'Norfolkinsel' },
  { name: 'Norway – Norge / Noreg', id: 'Norwegen' },
  { name: 'Oman – عمان (‘Umān)', id: 'Oman' },
  { name: 'Pakistan – پاکستان (Pākistān)', id: 'Pakistan' },
  { name: 'Palau – Belau', id: 'Palau' },
  { name: 'Palestine – فلسطين (Filasṭīn)', id: 'Palestina' },
  { name: 'Panama – Panamá', id: 'Panama' },
  { name: 'Papua New Guinea – Papua New Guinea', id: 'Papua-Neuguinea' },
  { name: 'Paraguay – Paraguay', id: 'Paraguay' },
  { name: 'Peru – Perú / Piruw', id: 'Peru' },
  { name: 'Philippines – Pilipinas / Republika ng Pilipinas', id: 'Philippinen' },
  { name: 'Pitcairn Islands – Pitcairn Islands', id: 'Pitcairninseln' },
  { name: 'Puerto Rico – Puerto Rico', id: 'Puerto Rico' },
  { name: 'Poland – Polska', id: 'Polen' },
  { name: 'Portugal – Portugal', id: 'Portugal' },
  { name: 'Qatar – قطر (Qaṭar)', id: 'Qatar' },
  { name: 'Romania – România', id: 'Rumänien' },
  { name: 'Réunion – La Réunion', id: 'Réunion' },
  { name: 'Russia – Россия (Rossiya)', id: 'Russland' },
  { name: 'Rwanda – Rwanda / Repubulika y’u Rwanda', id: 'Ruanda' },
  { name: 'Saint Barthélemy – Saint-Barthélemy', id: 'St. Barthélemy' },
  { name: 'Saint Helena – Saint Helena', id: 'St. Helena' },
  { name: 'Saint Kitts and Nevis – Saint Kitts and Nevis', id: 'St. Kitts/Nevis' },
  { name: 'Saint Lucia – Saint Lucia', id: 'St. Lucia' },
  { name: 'Saint Martin – Saint-Martin', id: 'St. Martin' },
  { name: 'Saint Pierre and Miquelon – Saint-Pierre-et-Miquelon', id: 'St. Pierre und Miquelon' },
  { name: 'Saint Vincent and the Grenadines – Saint Vincent and the Grenadines', id: 'St. Vincent/Die Grenadinen' },
  { name: 'Samoa – Samoa', id: 'Samoa' },
  { name: 'San Marino – San Marino', id: 'San Marino' },
  { name: 'Sao Tome and Principe – São Tomé e Príncipe', id: 'São Tomé/Príncipe' },
  { name: 'Saudi Arabia – المملكة العربية السعودية (Al-Mamlakah Al-‘Arabīyah As-Su‘ūdīyah)', id: 'Saudi-Arabien' },
  { name: 'Senegal – Sénégal', id: 'Senegal' },
  { name: 'Serbia – Србија (Srbija)', id: 'Serbien' },
  { name: 'Seychelles – Seychelles', id: 'Seychellen' },
  { name: 'Sierra Leone – Sierra Leone', id: 'Sierra Leone' },
  { name: 'Singapore – Singapore / 新加坡 (Xīnjiāpō)', id: 'Singapur' },
  { name: 'Slovakia – Slovensko', id: 'Slowakische Republik' },
  { name: 'Slovenia – Slovenija', id: 'Slowenien' },
  { name: 'Solomon Islands – Solomon Islands', id: 'Salomonen' },
  { name: 'Somalia – Soomaaliya', id: 'Somalia' },
  { name: 'South Africa – South Africa', id: 'Südafrika' },
  { name: 'South Korea – 대한민국 (Daehan Minguk)', id: 'Südkorea' },
  { name: 'South Sudan – South Sudan', id: 'Südsudan' },
  {
    name: 'South Georgia and the South Sandwich Islands – Südgeorgien und die Südlichen Sandwichinseln',
    id: 'Südgeorgien/Südlichen Sandwichinseln',
  },
  { name: 'Spain – España', id: 'Spanien' },
  { name: 'Sri Lanka – ශ්‍රී ලංකා (Śrī Laṃkā) / இலங்கை (Ilaṅkai)', id: 'Sri Lanka' },
  { name: 'Sudan – السودان (As-Sūdān)', id: 'Sudan' },
  { name: 'Suriname – Suriname', id: 'Surinam' },
  { name: 'Svalbard and Jan Mayen – Svalbard og Jan Mayen', id: 'Svalbard/Jan Mayen' },
  { name: 'Sweden – Sverige', id: 'Schweden' },
  { name: 'Syria – سوريا (Sūriyā)', id: 'Syrien' },
  { name: 'Taiwan – 台灣 (Táiwān)', id: 'Taiwan' },
  { name: 'Tajikistan – Тоҷикистон (Tojikiston)', id: 'Tadschikistan' },
  { name: 'Tanzania – Tanzania', id: 'Tansania' },
  { name: 'Thailand – ประเทศไทย (Prathet Thai)', id: 'Thailand' },
  { name: 'Togo – Togo', id: 'Togo' },
  { name: 'Tonga – Tonga', id: 'Tonga' },
  { name: 'Tokelau – Tokelau', id: 'Tokelau' },
  { name: 'Trinidad and Tobago – Trinidad and Tobago', id: 'Trinidad und Tobago' },
  { name: 'Tunisia – تونس (Tūnis)', id: 'Tunisien' },
  { name: 'Turkey – Türkiye', id: 'Türkei' },
  { name: 'Turks and Caicos Islands – Turks- und Caicosinseln', id: 'Turks- und Caicosinseln' },
  { name: 'Turkmenistan – Türkmenistan', id: 'Turkmenistan' },
  { name: 'Tuvalu – Tuvalu', id: 'Tuvalu' },
  { name: 'Uganda – Uganda', id: 'Uganda' },
  { name: 'Ukraine – Україна (Ukraina)', id: 'Ukraine' },
  {
    name: 'United Arab Emirates – الإمارات العربية المتحدة (Al-Imārāt Al-‘Arabīyah Al-Muttaḥidah)',
    id: 'Vereinigte Arabische Emirate',
  },
  { name: 'United Kingdom – United Kingdom', id: 'Großbritannien' },
  { name: 'United States – United States', id: 'USA' },
  { name: 'United States Virgin Islands – United States Virgin Islands', id: 'Jungferninseln, Amerikanische' },
  { name: 'United States Minor Islands', id: 'United States Minor Islands' },
  { name: 'Uruguay – Uruguay', id: 'Uruguay' },
  { name: 'Uzbekistan – Oʻzbekiston', id: 'Usbekistan' },
  { name: 'Vanuatu – Vanuatu', id: 'Vanuatu' },
  { name: 'Vatican City – Città del Vaticano', id: 'Vatikanstadt' },
  { name: 'Venezuela – Venezuela', id: 'Venezuela' },
  { name: 'Vietnam – Việt Nam', id: 'Vietnam' },
  { name: 'Wallis und Futuna', id: 'Wallis/Futuna' },
  { name: 'West Sahara – الصحراء الغربية (Al-Ṣaḥrāʾ Al-Gharbīyah)', id: 'Westsahara' },
  { name: 'Yemen – اليمن (Al-Yaman)', id: 'Jemen' },
  { name: 'Zambia – Zambia', id: 'Sambia' },
  { name: 'Zimbabwe – Zimbabwe', id: 'Simbabwe' },
];

export const countriesMap = countries.reduce((acc, { name, id }) => {
  acc[id] = name;
  return acc;
}, {} as Record<string, string>);
